import axios from 'axios';
import {useState} from 'react';
import { useNavigate } from 'react-router-dom';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import Grid from '@mui/material/Grid';

import LoadListListItem from "../LoadList/LoadListListItem";
import LoadListDetailsProjectEditProjectList from './LoadListDetailsProjectEditProjectList';

import { useSessionContext } from '../../../contexts/SessionContext';

export default function LoadProjectEdit(props) {
    console.debug('RTS Break LoadProjectEdit');

    const history = useNavigate();

    const {userAuthToken, apiRoot} = useSessionContext();

    const [showErrorModal, setShowErrorModal] = useState(false);
    const [errorBody, setErrorBody] = useState("");
    const [errorTitle, setErrorTitle] = useState("Validation Error");

    const [project, setProject] = useState(props.data.project);

    function handleSubmit(e) {
        e.preventDefault();

        let apiObj = props.data;
        apiObj.Project = project;

        let apiURL = apiRoot + "/Loads/UpdateLoad/" + apiObj.idGuid;
        axios
        .put(
            apiURL,
            apiObj, 
            {headers:{'Authorization': 'Bearer ' + userAuthToken.token }}
        )
        .then(response => {
            window.scrollTo(0,0);
            history(-1);
        })
        .catch(error => {
            setErrorTitle("Update Error");
            setErrorBody("An error has occured.  Please review the console log for details.");
            console.log("RTS UpdateLoad Error", error);
            setShowErrorModal(true);
        });
    } 


    function showManagerName(){
        if(props.data.project==null){
            return "";
        }
        else{
            if(props.data.project.manager==null){
                return "";
            }
            else{
                return props.data.project.manager.firstName + " " + props.data.project.manager.lastName;
            }
        }
    }


    return (
        <Box>
            <Dialog open={showErrorModal} onClose={()=>{setShowErrorModal(false);}}>
                <DialogTitle>{errorTitle}</DialogTitle>
                <DialogContent>
                    <DialogContentText>{errorBody}</DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button variant="contained" onClick={e => {setShowErrorModal(false);}}>Close</Button>
                </DialogActions>
            </Dialog> 
            <Box>
                <LoadListListItem data={props.data} user={props.user} hideLinks={true}/>
            </Box>
            <Box sx={{display:'flex', justifyContent:'center', alignItems:'center', pt:2}}>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                <form onSubmit={handleSubmit} style={{width:'400px'}}>
                    <Box sx={{display:'flex', alignItems:'center'}}>
                        <Typography variant='h6' sx={{mb:2, mt:1}}>Selected New Project For Reel</Typography>
                    </Box>
                    <Box sx={{border:'1px solid #e2e8f0', borderRadius:'5px', p:1}}>        
                        <Box sx={{display:'flex'}}>
                            <Typography variant="body2" sx={{fontWeight:'bold'}}>Project Name:</Typography>
                            <Typography variant="body2" sx={{ml:'2px'}}>{project==null?"No Project":project.name}</Typography>
                        </Box>
                        <Box sx={{display:'flex'}}>
                            <Typography variant="body2" sx={{fontWeight:'bold'}}>Description:</Typography>
                            <Typography variant="body2" sx={{ml:'2px'}}>{project==null?"":project.desc}</Typography>
                        </Box>
                        <Box sx={{display:'flex'}}>
                            <Typography variant="body2" sx={{fontWeight:'bold'}}>Manager:</Typography>
                            <Typography variant="body2" sx={{ml:'2px'}}>{showManagerName()}</Typography>
                        </Box>
                        <Box sx={{display:'flex'}}>
                            <Typography variant="body2" sx={{fontWeight:'bold'}}>External Id:</Typography>
                            <Typography variant="body2" sx={{ml:'2px'}}>{project==null?"":project.extId}</Typography>
                        </Box>
                        <Grid container>
                            <Grid item xs={12} sm={6}>
                                <Box sx={{display:'flex'}}>
                                    <Typography variant="body2" sx={{fontWeight:'bold'}}>Start Date:</Typography>
                                    <Typography variant="body2" sx={{ml:'2px'}}>{project==null?"":project.startDate!=null?(new Date(project.startDate)).toLocaleDateString("en-US"):""}</Typography>
                                </Box>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <Box sx={{display:'flex'}}>
                                    <Typography variant="body2" sx={{fontWeight:'bold'}}>End Date:</Typography>
                                    <Typography variant="body2" sx={{ml:'2px'}}>{project==null?"":project.endDate!=null?(new Date(project.endDate)).toLocaleDateString("en-US"):""}</Typography>
                                </Box>
                            </Grid>
                        </Grid>
                    </Box>
                    <Box>
                        <LoadListDetailsProjectEditProjectList project={project} setProjectFx={setProject} />
                    </Box>
                    <Box sx={{display:'flex', justifyContent:'center', alignItems:'center', pt:2}}>
                        <Box xs={{display:'flex'}}>
                            <Button type="submit" variant="contained" sx={{mr:2}}>Set Project</Button>
                        </Box>
                    </Box>
                </form>
                </LocalizationProvider>
            </Box>
        </Box>
    );

}
